import Vue from "vue";
import Vuex from "vuex";
const version = process.env.VUE_APP_VERSION; // page version

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 公共cdkey
    cdkeyList: {
      code0: "MIRSTORE", // 商店预约礼包码
    },
    // 用户信息
    userInfo: {
      aid: 1,
      source: Number,// 广告来源 1.GP 2.GP_Analytics 3.FB 4.TT 5.LINE
      token: String,
      phone: Number,
      time_states: 1 // 状态 1:活动进行中 2:活动未开始 3:活动已结束
    },
    // 登陆信息
    loginInfo: {
      cdkey: Array, // 兑换码
      down_reward: Number, // 已抽奖次数
      invited_nums: Number,// 邀请人数	
      invited_uid: Number, // 抽奖次数
      invited_code: String, // 邀请码
      raffle_nums: Number, // 抽奖次数
      subnums: Number // 预约总人数
    },
    // 网站链接
    storeUrl: {
      appStroe: 'https://apps.apple.com/us/app/%EC%88%98%EB%9D%BC%EC%9D%98-%EC%84%9C/id1615928772',
      googlePlay: 'https://sus.onelink.me/8GCu/preregister',
      oneStore: 'https://sus.onelink.me/8GCu/preregister',
      weMade: 'https://sus.onelink.me/8GCu/preregister',
    },
    // 网站链接
    shareUrl: {
      share_url: 'https://apps.apple.com/us/app/%EC%88%98%EB%9D%BC%EC%9D%98-%EC%84%9C/id1615928772',
      facebook: 'https://apps.apple.com/us/app/%EC%88%98%EB%9D%BC%EC%9D%98-%EC%84%9C/id1615928772',
      naverCafe: 'https://sus.onelink.me/8GCu/preregister',
      naverLounge: 'https://sus.onelink.me/8GCu/preregister'
    },
    // 
  },
  mutations: {
    // 设置用户信息
    SET_USERINFO: (state, parmas) => {
      state.userInfo = parmas;
    },
    // 设置登陆信息
    SET_LOGININFO: (state, parmas) => {
      state.loginInfo = parmas;
    },
    // 设置token
    SET_TOKEN: (state, parmas) => {
      state.userInfo.token = parmas;
    },
    // 设置phone
    SET_PHONE: (state, parmas) => {
      state.userInfo.phone = parmas;
    },
    // 设置subnums
    SET_SUBNUMS: (state, parmas) => {
      state.userInfo.subnums = parmas;
    },
    // 设置time_states
    SET_TIMESTATES: (state, parmas) => {
      state.userInfo.time_states = parmas;
    }
  },
  actions: {
    // 设置用户信息
    setUserInfo({ commit }, params) {
      commit("SET_USERINFO", params);
    },
    // 设置登陆信息
    setLoginInfo({ commit }, params) {
      commit("SET_LOGININFO", params);
    },
    // 设置token
    setToken({ commit }, params) {
      commit("SET_TOKEN", params);
    },
    // 设置subnums
    setSubnums({ commit }, params) {
      commit("SET_SUBNUMS", params);
    },
    // 设置phone
    setPhone({ commit }, params) {
      commit("SET_PHONE", params);
    },
    // 设置time_states
    setTimeStates({ commit }, params) {
      commit("SET_TIMESTATES", params);
    }
  },
  modules: {}
});
